export enum TextTrackLanguage {
    'en' = 'English',
    'es' = 'Spanish',
    'fr' = 'French'
}